const configuredApiUrl = process.env.REACT_APP_API_URL;

if (!configuredApiUrl) {
  throw new Error('REACT_APP_API_URL is not configured. Add it to the project .env file.');
}

export const apiBaseUrl = configuredApiUrl.replace(/\/+$/, '');

export const apiEndpoints = {
  featuredListings: `${apiBaseUrl}/api/featuredlistings.ashx`,
  propertyListings: `${apiBaseUrl}/api/propertylistings.ashx`,
  propertyDetails: `${apiBaseUrl}/api/propertydetails.ashx`,
  propertyEnquiry: `${apiBaseUrl}/api/propertyenquiry.ashx`,
};
